import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Headertwo';
import Footer from '../layouts/Footer';
import Breadcrumb from '../layouts/Breadcrumb';
import Content from '../sections/room-sell-details/Content';

const pagelocation = 'Room Details'

class SellDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nome: "",
            foto:null,
        };
        this.changeInfo = this.changeInfo.bind(this);
    }
    async changeInfo(name,foto) {
        console.log("### CHANGE INFO ROOM DETEILS")
        this.setState({nome:name,foto:foto})
    }
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Best House Cilento - Search</title>
                    <meta name="name" content="besthousecilento" />
                    <meta name="name" content="Best House Cilento"/>
                    <meta name="place" content="cilento"/>
                    <meta name="place" content="Cilento"/>
                    <meta name="name" content="besthouse"/>
                    <meta name="name" content="homebesthousecilento"/>
                    <meta name="name" content="ricerca appartamenti"/>
                    <meta name="name" content="reasearch rooms"/>
                    <meta name="name" content="ascea"/>
                    <meta name="name" content="rooms"/>
                    <meta name="name" content="appartamenti ascea"/>
                    <meta name="name" content="appartamenti Ascea"/>
                    <meta name="name" content="appartamenti Ascea"/>

                </MetaTags>
                <Header home={""}/>
                <Breadcrumb nome={this.state.nome} foto={this.state.foto} />
                <Content roomId={this.props.match.params.id} setName={this.changeInfo}/>
                <Footer />
            </Fragment>
        );
    }
}

export default SellDetails;